import { AmountLabel } from "./Components"

export const Amount = ({amount, currency, color, bold}) => {
    return (
        <AmountLabel $color={amount > 0?color:null} $bold={amount > 0?bold:null}>{(currency?currency.symbol:"")+" "+amount}</AmountLabel>
        
    )
}